"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var video_1 = require("@wix/wix-vod-api-site-based/dist/src/public/services/video/video");
var to_error_1 = require("../../parsers/to-error");
var context_1 = require("@wix/wix-vod-shared/dist/src/common/utils/context");
var hosts_1 = require("@wix/wix-vod-constants/dist/env/hosts");
exports.createService = function () { return new video_1.PublicVideo(); };
exports.service = exports.createService();
exports.ctx = context_1.createCtx(exports.service);
exports.getDownloadUrl = function (videoId, channelId, instance) {
    return video_1.PublicVideo.getDownloadUrl(hosts_1.PRODUCTION_HOSTS.catalog, videoId, channelId, instance);
};
exports.getVideoUrls = function (videoId, channelId, instance) {
    // const service = ctx.getValue();
    return exports.service
        .getVideoUrls(videoId, channelId, instance)
        .then(function (response) { return response.data; })
        .catch(to_error_1.toError);
};
//# sourceMappingURL=video.js.map